module.exports = __webpack_public_path__ + "img/logo2.169acbf5.png";